import React from 'react';
import { Collapse, List } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../store';
import { TableSecProps } from './props';
import { maskCurrency } from '../../../../../../../utils/mask';
import { RowLine, SpanBlock } from './styles';

const CardMobile: React.FC<TableSecProps> = () => {
  const { Panel } = Collapse;
  const loadingItensNotaEntrada = useSelector(
    (state: ApplicationState) => state.Movimentacoes.loading
  );
  const itensNotaEntrada = useSelector(
    (state: ApplicationState) => state.Movimentacoes.itensNotaEntrada
  );
  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={{
        defaultPageSize: 3,
        defaultCurrent: 1,
        showSizeChanger: true,
        pageSizeOptions: ['3', '5', '10', '20', '50'],
        locale: { items_per_page: '/páginas' },
      }}
      loading={loadingItensNotaEntrada}
      dataSource={itensNotaEntrada}
      renderItem={(item: any) => (
        <List.Item>
          <Collapse key={item.nuNota}>
            <Panel header={`${item.codProduto} - ${item.descricaoProduto}`} key={item.nuNota}>
              <RowLine>
                <p>
                  <strong>Código produto: </strong>
                  <SpanBlock> {item.codProduto}</SpanBlock>
                </p>
                <p>
                  <strong>Código referência: </strong>
                  <SpanBlock>{item.referencia}</SpanBlock>
                </p>
                <p>
                  <strong>Produto: </strong>
                  <SpanBlock> {item.descricaoProduto}</SpanBlock>
                </p>
                <p>
                  <strong>Lote: </strong>
                  <SpanBlock> {item.controle}</SpanBlock>
                </p>
              </RowLine>
              <RowLine>
                <p>
                  <strong>Quantidade: </strong>
                  <SpanBlock> {item.quantidade}</SpanBlock>
                </p>
                <p>
                  <strong>Unidade: </strong>
                  <SpanBlock> {item.volume}</SpanBlock>
                </p>
              </RowLine>
              <RowLine>
                <p>
                  <strong>Peso bruto: </strong>
                  <SpanBlock> {item.pesoBruto + ' KG'}</SpanBlock>
                </p>
                <p>
                  <strong>Valor da mercadoria: </strong>
                  <SpanBlock> {maskCurrency(item.valorTotal)} </SpanBlock>
                </p>
              </RowLine>
              <p style={{ wordWrap: 'break-word' }}>{item.chaveNfe}</p>
              <hr />
            </Panel>
          </Collapse>
        </List.Item>
      )}
    />
  );
};

export default CardMobile;
